// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#tabContainer .el-dialog__wrapper {\n  pointer-events: none;\n}\n#tabContainer .el-dialog {\n  pointer-events: auto;\n}\n", ""]);
// Exports
module.exports = exports;
